import { css, CSSObject, DefaultTheme, ThemeProps } from 'styled-components';
import { MEDIA_QUERY, MediaQuery } from './BreakpointRange';

export interface ResponsiveIntervals<T> {
    phoneOnly?: T;
    largePhoneUp?: T;
    largePhoneOnly?: T;
    largePhoneMax?: T;
    tabletUp?: T;
    tabletOnly?: T;
    tabletMax?: T;
    desktopUp?: T;
    desktopOnly?: T;
    desktopMax?: T;
    largeDesktopOnly?: T;
}

type GetStylesCallback<T> = (props: T & ThemeProps<DefaultTheme>) => CSSObject;
type MediaQueryProp = Exclude<MediaQuery, 'largeDesktopMax' | 'print'>;

export const getResponsiveStyles =
    <T extends ResponsiveIntervals<T>>(getComponentStyles: GetStylesCallback<T>) =>
    (props: T) => {
        const availableBreakpointsInProps = Object.keys(props).filter(
            (prop) => prop in MEDIA_QUERY && Object.keys(props[prop as MediaQueryProp] || {}).length
        ) as MediaQueryProp[];

        return availableBreakpointsInProps.map((breakpointName) => {
            const breakpointRules = props[breakpointName];

            if (!breakpointRules) {
                return null;
            }

            return css`
                ${MEDIA_QUERY[breakpointName]} {
                    ${({ theme }) => getComponentStyles({ ...breakpointRules, theme })}
                }
            `;
        });
    };
